import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Input from '../../components/Input'
import Textarea from '../../components/Textarea';
import {Button, buttonTypes} from '../../components/Button';
import {validateContactUs} from "../../utils/validationUtils";
import {contactUs} from "../Main/Actions";
import './ContactUs.scss';

class ContactUs extends React.Component {

  state = {
    name: '',
    email: '',
    text: '',
    error: {},
    isRequestSent: false,
  };

  componentWillReceiveProps(next) {
    if(next.promiseApi.isPending){
      this.setState({isRequestSent: true})
    }
    if(this.state.isRequestSent && next.promiseApi.isSuccess){
      this.setState({
        name: '',
        email: '',
        text: '',
        error: {},
        isRequestSent: false,
      });
      NotificationManager.success('Message sent successfully', '', ((5 * 1000)));
    }
  }

  handleChange = (e) => {
    const {name, value} = e.target;
    const {error} = this.state;
    if (value && value.length > 1000) {
      this.setState({error: {...error, [name]: 'Max length 10000'}})
    } else {
      this.setState({[name]: value, error: {...error, [name]: ''}})
    }
  };

  send = () => {
    const validate = validateContactUs({...this.state});
    if (validate.isValid) {
      this.props.submit({
        email: this.state.email,
        name: this.state.name,
        message: this.state.text,
      });
    } else {
      this.setState({error: {...validate.error}})
    }
  };

  render() {
    const {name, email, text, error} = this.state;
    const {promiseApi} = this.props;
    return (
      <div className="contact-us">
        <h2 className="title-page">Contact us</h2>
        <div className="contact-us__group">
          <div className="contact-us__block contact-us__form">
            <h3 className="contact-us__form-title">Problems? Just tell us :)</h3>
            <Input
              label="Full name"
              placeholder="Full name"
              name="name"
              value={name}
              error={error.name}
              onChange={this.handleChange}
            />
            <Input
              label="E-mail"
              placeholder="E-mail"
              value={email}
              name="email"
              error={error.email}
              onChange={this.handleChange}
            />
            <Textarea
              name="text"
              value={text}
              label="Your message"
              error={error.text}
              onChange={this.handleChange}
            />
            <Button
              type={buttonTypes.AUTHENTICATION}
              name={promiseApi.isPending ? 'Wait please' : 'Get in touch'}
              onClick={this.send}
              disabled={promiseApi.isPending}
            />
          </div>
          <div className="contact-us__block">
            <div className="contact-us__row">
              <p className="contact-us__address ">
                <i className="ti-location-pin" />
                <span>United States</span>
                <span>Ashbury Heights, San Francisco, Ca</span>
              </p>
            </div>
            <div className="contact-us__row">
              <a href="tel:+14154540077" className="contact-us__link contact-us__phone">
                <i className="ti-mobile" />
                +1 415 454-00-77
              </a>
              <a href="mailto:desitours@desi.com" className="contact-us__link contact-us__mail">
                <i className="ti-email" />
                desitours@desi.com
              </a>
            </div>
          </div>
        </div>
        <NotificationContainer />
      </div>
    )
  }
}

ContactUs.propTypes = {
  submit: PropTypes.func,
  promiseApi: PropTypes.object,
};

export default connect(
  (s)=>({
    promiseApi: s.main.promise.contactUs,
  }),
  (d)=>({
    submit: (data) => {
      d(contactUs(data))
    }
  })
)(ContactUs);


// WEBPACK FOOTER //
// ./src/app/containers/StaticPages/ContactUs.js